import styled from "styled-components";
import theme from "~/styles/theme";

export const BgParticipantProducts = styled.div`
  background-color: white;
  width: 100%;
  border-radius: 0 0 32px 32px;
  padding: 0 16px 48px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    border-radius: 0 0 48px 48px;
  }

  p {
    color: ${theme.palette.neutral.primary.key};
    font-weight: 500;
  }
`;

export const ProductsHolder = styled.section`
  width: 100%;
  margin-bottom: 16px;
  margin-top: -60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 40px;
    margin-top: -150px;
  }

  img {
    margin-bottom: 40px;
  }
`;
export const TitleSection = styled.div`
  text-align: center;
  margin-bottom: 30px;
  
  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: flex;
    flex-direction: column;
  }

  h3 {
    font-size: 28px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      font-size: 48px;
    }
  }

  img {
    margin-bottom: -46px;
    max-width: 333px;
    margin-left: 10px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin-right: 54px;
      max-width: 380px;
      width: 100%;
      margin-left: 0;
      margin-bottom: -60px;
      max-width: auto;
    }
  }

  h3 {
    margin-bottom: 24px;
    text-align: center;
    max-width: 706px;
  }

  p {
    text-align: center;
    font-weight: 400;
  }
`;
export const ProductMargin = styled.div`
  margin: 0 8px 0;

  @media (min-width: ${theme.breakpoints.values.lg}px) {
    margin: 0;
  }
`;

export const Product = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 144px;
  border-radius: 20px;
  width: 100%;
  height: 154px;
  padding: 24px;
  border-radius: 20px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Logo = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin: 40px 0 48px;

@media (min-width: ${theme.breakpoints.values.md}px) {
  margin: 64px 0 80px;
}
`;

export const Brand = styled.div`
  background: #f0f0f0;
  border-radius: 15px;
  padding: 8px 16px;
  margin-bottom: 8px;
`;

export const BrandHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 10px 0;
`;

export const BrandHeadTitle = styled.div`
`;

export const BrandHeadButton = styled.div`
  color: #0d5ba8;
  font-size: 32px;
`;

export const BrandContainer = styled.div`
`;
